(function(){
  if(window.__bmpDeliveryFix)return;window.__bmpDeliveryFix=true;
  /* Fourchette de livraison BEEMAC (validée 23/09/2026) :
     expédié en 24/48h (1 à 2 jours ouvrés) + livré en 2 à 4 jours ouvrés
     = livraison entre J+3 et J+6 jours ouvrés, comptés à partir de demain.
     Jours ouvrés = lundi à vendredi, hors jours fériés français. Aucune heure limite. */
  var MIN_BUSINESS_DAYS=3;
  var MAX_BUSINESS_DAYS=6;

  function easter(year){
    var a=year%19;
    var b=Math.floor(year/100);
    var c=year%100;
    var d=Math.floor(b/4);
    var e=b%4;
    var f=Math.floor((b+8)/25);
    var g=Math.floor((b-f+1)/3);
    var h=(19*a+b-d-g+15)%30;
    var i=Math.floor(c/4);
    var k=c%4;
    var l=(32+2*e+2*i-h-k)%7;
    var m=Math.floor((a+11*h+22*l)/451);
    var month=Math.floor((h+l-7*m+114)/31);
    var day=((h+l-7*m+114)%31)+1;
    return new Date(year,month-1,day);
  }

  function fixedHolidays(year){
    return [
      new Date(year,0,1),
      new Date(year,4,1),
      new Date(year,4,8),
      new Date(year,6,14),
      new Date(year,7,15),
      new Date(year,10,1),
      new Date(year,10,11),
      new Date(year,11,25)
    ];
  }

  function buildHolidays(year){
    var e=easter(year);
    var lundiPaques=new Date(e);lundiPaques.setDate(e.getDate()+1);
    var ascension=new Date(e);ascension.setDate(e.getDate()+39);
    var lundiPentecote=new Date(e);lundiPentecote.setDate(e.getDate()+50);
    return fixedHolidays(year).concat([lundiPaques,ascension,lundiPentecote]);
  }

  function sameDay(a,b){return a.getFullYear()===b.getFullYear()&&a.getMonth()===b.getMonth()&&a.getDate()===b.getDate();}

  var HOLIDAY_CACHE={};
  function isHoliday(date){
    var y=date.getFullYear();
    if(!HOLIDAY_CACHE[y])HOLIDAY_CACHE[y]=buildHolidays(y);
    for(var i=0;i<HOLIDAY_CACHE[y].length;i++){if(sameDay(HOLIDAY_CACHE[y][i],date))return true;}
    return false;
  }

  function isBusinessDay(date){
    var dow=date.getDay();
    if(dow===0||dow===6)return false;
    if(isHoliday(date))return false;
    return true;
  }

  function addBusinessDays(startDate,daysToAdd){
    var d=new Date(startDate);
    var added=0;
    while(added<daysToAdd){
      d.setDate(d.getDate()+1);
      if(isBusinessDay(d))added++;
    }
    return d;
  }

  function fix(){
    var dateEl=document.getElementById('bmp-delivery-date');
    var subEl=document.getElementById('bmp-delivery-sub');
    /* Panier (26/09/2026) : meme calcul, affiche dans les elements [data-bm-eta] */
    var etaEls=document.querySelectorAll('[data-bm-eta]');
    if((!dateEl||!subEl)&&!etaEls.length)return;
    var now=new Date();
    now.setHours(12,0,0,0);
    var dMin=addBusinessDays(now,MIN_BUSINESS_DAYS);
    var dMax=addBusinessDays(now,MAX_BUSINESS_DAYS);
    var jours=['dim.','lun.','mar.','mer.','jeu.','ven.','sam.'];
    var mois=['janv.','févr.','mars','avr.','mai','juin','juil.','août','sept.','oct.','nov.','déc.'];
    var sameMonth=dMin.getMonth()===dMax.getMonth()&&dMin.getFullYear()===dMax.getFullYear();
    var minTxt=jours[dMin.getDay()]+' '+dMin.getDate()+(sameMonth?'':' '+mois[dMin.getMonth()]);
    var maxTxt=jours[dMax.getDay()]+' '+dMax.getDate()+' '+mois[dMax.getMonth()];
    if(dateEl&&subEl){
      dateEl.textContent='Livré entre le '+minTxt+' et le '+maxTxt;
      subEl.textContent='Expédié en 24/48h, livré en 2 à 4 jours ouvrés';
    }
    for(var j=0;j<etaEls.length;j++){etaEls[j].textContent='Livraison estimée entre le '+minTxt+' et le '+maxTxt;}
  }
  function run(){setTimeout(fix,150);setTimeout(fix,500);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',run);else run();
})();